export const BACKOFFICE_API_URL = process.env.REACT_APP_BACKOFFICE_API_URL || 'http://localhost:8081/app/backoffice';
export const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_URL || 'http://localhost:8082/app/customer';
export const MERCHANT_API_URL = process.env.REACT_APP_MERCHANT_API_URL || 'http://localhost:8083/app/merchant';
export const PAYMENTS_API_URL = process.env.REACT_APP_PAYMENTS_API_URL || 'http://localhost:8084/app/payments';
